import type {ReactNode} from 'react';

import {Card} from '../card/card';
import {Stack} from '../layout/stack/stack';
import {AiBadge} from '../summary/ai-badge';
import {Body} from '../typography/body';

interface Props {
    content: ReactNode;
    title?: string;
}

export function AiCallout(props: Props) {
    return (
        <Card hasBorder={true} borderRadius={8} fitHeight={true}>
            <div className='flex flex-dir-col gap-8 pad-12'>
                <Stack isHorizontal={true} justifyContent='space-between'>
                    {props.title && (
                        <Body size='small' isBold={true}>
                            {props.title}
                        </Body>
                    )}
                    <AiBadge />
                </Stack>
                {props.content}
            </div>
        </Card>
    );
}
